export default (set, get, sizes) => set(
  () => ({
    enabledSizes: sizes
  }),
  false,
  { type: 'updateEnabledSizes', payload: sizes }
);
